import { useState } from "react";
import { Avatar, Box } from "@mantine/core";

interface WizzyAvatarProps {
  wizzyImagePre: string;
  wizzyImagePost: string;
  size?: number;
  onClick?: () => void;
}

/**
 * Animated Wizzy avatar component with hover effect.
 * Shows wizzyImagePre by default, transitions to wizzyImagePost on hover.
 * Optionally clickable to navigate back to the first onboarding step.
 */
export const WizzyAvatar = ({
  wizzyImagePre,
  wizzyImagePost,
  size = 260,
  onClick,
}: WizzyAvatarProps) => {
  const [isWizzyHovered, setIsWizzyHovered] = useState(false);

  const wizzyStyle = (active?: boolean) =>
    ({
      position: "absolute",
      inset: 0,
      transition: "opacity 220ms ease-in-out",
      willChange: "opacity",
      opacity: isWizzyHovered ? (active ? 1 : 0) : active ? 0 : 1,
    }) as const;

  return (
    <Box
      style={{
        position: "relative",
        width: size,
        height: size,
        cursor: onClick ? "pointer" : "default",
      }}
      onMouseEnter={() => setIsWizzyHovered(true)}
      onMouseLeave={() => setIsWizzyHovered(false)}
      onClick={onClick}
    >
      <Avatar
        src={wizzyImagePre}
        alt="Wizzy avatar"
        size={size}
        radius="xl"
        style={wizzyStyle()}
      />
      <Avatar
        src={wizzyImagePost}
        alt="Wizzy waving"
        size={size}
        radius="xl"
        style={wizzyStyle(true)}
      />
    </Box>
  );
};
